import { useCallback } from 'react'
import { FormValues, getDataForUpdate } from '../../../helpers/tables/get-data-for-update'
import { useErrorModal } from '../../../hooks/api/use-error-modal'
import { useUpdateAndCalculateShipmentMutation } from '../../../store/api/shipments-api'
import Shipment from '../../../types/api/shipment'
import { EndpointQueryParameters } from '../../../types/strapi/strapi'
import { normalizeShipmentUpdateData } from '../helpers/normalize-shipment-update-data'
import { useUpdateQueryData } from './use-update-query-data'

const SHIPMENT_COMPONENT_KEYS = ['virtualStamp', 'lacquers'] as const

/** Сохранение значения из EditableCell с пересчётом отгрузки */
export function useUpdateShipmentProperty(queryArg: EndpointQueryParameters) {
    const [updateAndCalculateShipment, state] = useUpdateAndCalculateShipmentMutation()
    const updateQueryData = useUpdateQueryData(queryArg)

    useErrorModal(state, 'Ошибка обновления отгрузки')

    return useCallback(
        async (record: Shipment, formValues: FormValues) => {
            try {
                const raw = getDataForUpdate(record, formValues, {
                    componentKeys: SHIPMENT_COMPONENT_KEYS,
                })
                const data = normalizeShipmentUpdateData(raw)
                const res = await updateAndCalculateShipment({
                    docId: record.documentId,
                    body: { data: data as any },
                    queryParams: queryArg,
                })

                if (res.data) {
                    updateQueryData(res.data.data)
                }
            } catch {
                // ошибка обрабатывается хуком useErrorModal
            }
        },
        [updateAndCalculateShipment, queryArg, updateQueryData]
    )
}
